<template>
  <div class="query-container">
    <img class="logo" src="/static/images/naiture/logo.png" />
    <div class="rows-container">
      <div class="split-container">
        <div class="left">
          <img class="img-size" src="/static/images/naiture/orange.png" />
        </div>
        <div class="right">
          <img class="img-size" src="/static/images/naiture/red.png" />
        </div>
      </div>
      <div class="split-container2">
        <div class="left">
          <img class="img-size" src="/static/images/naiture/green.png" />
        </div>
        <div class="right">
          <img class="img-size" src="/static/images/naiture/gray.png" />
        </div>
      </div>
    </div>
    <div class="bottom-panel">
      <div class="inner-panel"></div>
      <div class="top-panel">
        <div class="header-row">
          <div class="text-content">Enter Manually</div>
          <img class="dian-img" src="/static/images/naiture/dian.png" />
        </div>
        <div class="query-box">
          <img class="query-icon" src="/static/images/naiture/query-icon.png" />
          <input class="query-input" type="text" placeholder="Enter 16-digit code" v-model="antiCode" maxlength="16" />
          <div class="query-button" @click="queryData">query</div>
        </div>
      </div>
    </div>
    <div class="modal-overlay" v-if="showModal">
      <div class="modal">
        <div class="modal-title">提示</div>
        <div class="modal-content">填写的防伪码不正确，请核对后再查询！</div>
        <div class="modal-button" @click="closeModal">重新填写</div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryAnti } from '../../api/api'

export default {
  name: 'NaitureQuery',
  data() {
    return {
      antiCode: '',
      eno: process.env.ENV_NUM === '1' ? '138885179492' : '138582119094',
      showModal: false,
      firstQueryTime: '',
      preQueryTime: ''
    }
  },
  methods: {
    async queryData() {
      if (this.antiCode.length !== 16) {
        this.showModal = true;
        return;
      }

      const res = await queryAnti(this.antiCode, this.eno);
      const data = res.data;

      if (data == null || data.code == "500") {
        this.showModal = true;
        return;
      }

      // 处理查询结果
      const replyCode = data.data.replyCode;

      if (replyCode === "300101" || replyCode === "300102") {
        this.firstQueryTime = data.data.firstQueryTime || '';
        this.preQueryTime = data.data.preQueryTime || '';
      } else if (replyCode === "300106") {
        this.showModal = true;
        return;

      } else {
        this.showModal = true;
        return;
      }

      const params = `c=${this.antiCode}&firstQueryTime=${encodeURIComponent(this.firstQueryTime || '')}&preQueryTime=${encodeURIComponent(this.preQueryTime || '')}&router=1`;
      window.location.href = `/naiture?${params}`;
    },
    closeModal() {
      this.showModal = false;
      this.antiCode = '';
    }
  }
}
</script>

<style scoped>
.query-container {
  width: 100vw;
  min-height: 100vh;
  background-color: rgb(0, 87, 89);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 6vh;
}

.logo {
  width: 30vw;
  margin-bottom: 3vh;
}

.rows-container {
  width: 85vw;
  display: flex;
  flex-direction: column;
  gap: 1.5vh;
}

.split-container,
.split-container2 {
  display: flex;
}

.left {
  flex: 1;
  display: flex;
  justify-content: center;
}

.right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.img-size {
  width: 40vw;
  height: auto;
  filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.4));
}

.bottom-panel {
  width: 100%;
  background-color: rgb(33, 117, 107);
  border-radius: 34px 34px 0 0;
  flex: 1;
  margin-top: 2vh;
  min-height: 200px;
  position: relative;
  z-index: 1;
}

.inner-panel {
  width: 100%;
  background-color: rgb(67, 152, 127);
  border-radius: 30px 30px 0 0;
  position: absolute;
  top: 27px;
  left: 0;
  z-index: 2;
  min-height: calc(100% - 27px);
}

.top-panel {
  width: 100%;
  background-color: white;
  border-radius: 25px 25px 0 0;
  position: absolute;
  top: 50px;
  left: 0;
  z-index: 3;
  min-height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.text-content {
  font-size: 5.5vw;
  color: rgb(30, 102, 104);
  margin-top: 1.5vh;
  font-weight: 400;
  margin-right: 1vw;
  font-family: 'Playfair Display', 'Times New Roman', serif;
  font-style: italic;
  font-weight: 500;
}

.dian-img {
  width: 38px;
  height: 24px;
  object-fit: contain;
  margin-top: 2vh;
  margin-right: 3vw;
}

.query-box {
  width: 100%;
  margin: 4vh auto 0;
  display: flex;
  align-items: center;
  padding: 1px;
  border-radius: 10px;
  position: relative;
  background: white;
}

.query-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 10px;
  padding: 1px;
  background: linear-gradient(135deg, rgb(0, 87, 89), rgb(66, 151, 127));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.query-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-left: 10px;
}

.query-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px 15px;
  font-size: 14px;
  background: transparent;
}

.query-input::placeholder {
  font-size: 14px;
  font-family: 'Playfair Display', 'Times New Roman', serif;
  font-style: italic;
  font-weight: 400;
}

.query-button {
  padding: 10px 20px;
  border-radius: 0 10px 10px 0;
  background-color: rgb(88, 171, 139);
  color: white;
  font-family: 'Playfair Display', 'Times New Roman', serif;
  font-style: italic;
  font-weight: bold;
  font-size: 20px;
  margin: -1px -1px -1px 0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background-color: rgba(64, 64, 64, 0.9);
  border-radius: 15px;
  padding: 30px 20px;
  width: 80vw;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.modal-title {
  font-size: 6vw;
  font-weight: bold;
  color: white;
}

.modal-content {
  font-size: 4.5vw;
  text-align: center;
  color: white;
  max-width: 70%;
}

.modal-button {
  padding: 10px 50px;
  background-color: rgb(88, 171, 139);
  color: white;
  border-radius: 25px;
  font-size: 4.5vw;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Naiture/Query.vue